module.exports = __webpack_public_path__ + "img/ly.2d35cc95.jpg";